const name = 'FloatIn';
const properties = { schema: {} };
const paramsMap = {
    top: { dx: 0, dy: -1, distance: 120 },
    right: { dx: 1, dy: 0, distance: 120 },
    bottom: { dx: 0, dy: 1, distance: 120 },
    left: { dx: -1, dy: 0, distance: 120 },
};
function animate(kit, elements, duration, delay, { direction = 'left', ...params } = {}) {
    const fromParams = paramsMap[direction];
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BaseFade', elements, duration, delay, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        ease: 'sineInOut',
    }));
    elements.forEach((element) => {
        const transformX = fromParams.dx * fromParams.distance;
        const transformY = fromParams.dy * fromParams.distance;
        sequence.add(kit.animate('BasePosition', element, duration, delay, {
            from: { x: transformX, y: transformY },
            ease: 'sineInOut',
        }), 0);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=floatIn.js.map